module.exports = __webpack_public_path__ + "img/e0b61ed77b04a2dab887259caea498ce.e0b61ed7.jpeg";